import { wagwebTheme } from '@/theme/wagwebTheme';
import React from 'react';
import { Typography, Props as TypographyProps } from '../Typography';
type Props = TypographyProps;
export const ArticleTitle = (props: Props) => <Typography mb="16px" mt={['16px', '16px', '8px']} {...props} color={wagwebTheme.colors.nero} variant="h1" fontFamily="muliBold" data-sentry-element="Typography" data-sentry-component="ArticleTitle" data-sentry-source-file="index.tsx" />;